import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});

const BlockMasterFrom = ({
  open,
  formValue,
  isDisabled,
  floors,
  handleClose,
  handleSubmit,
  handleInputChange,
}) => {
  const classes = useStyles();
  return (
    <>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <DialogTitle className="text-[#312C41] !text-[16px] !font-semibold">
            Fee Master
          </DialogTitle>

          <CancelRoundedIcon
            onClick={handleClose}
            className="bg-[white] !text-[#344767] !text-[1.7rem] !outline-none p-4 cursor-pointer"
          />
        </Box>

        <DialogContent>
          <Stack spacing={4} paddingLeft={2} paddingRight={2} paddingBottom={2}>
            <div className="grid grid-cols-2 gap-4 gap-y-5">
              <TextField
                required
                fullWidth
                name="name"
                type="text"
                id="outlined-required"
                label="Block Name"
                size="small"
                className={classes.input}
                value={formValue.name}
                onChange={handleInputChange}
              />

              <FormControl required size="small">
                <InputLabel size="small">Floor</InputLabel>
                <Select
                  label="Floor"
                  name="floorId"
                  value={formValue.floorId}
                  onChange={handleInputChange}
                >
                  {floors?.map((obj) => {
                    if (obj.deleted === false) {
                      return <MenuItem value={obj.id}>{obj.name}</MenuItem>;
                    } else {
                      return null;
                    }
                  })}
                </Select>
              </FormControl>
              <TextField
                required
                fullWidth
                name="description"
                type="text"
                id="outlined-required"
                label="Description"
                size="small"
                className={classes.input + " col-span-2"}
                value={formValue.description}
                onChange={handleInputChange}
              />
            </div>
            <Button
              disabled={!isDisabled}
              onClick={handleSubmit}
              sx={{
                textTransform: "none",
                background: !isDisabled
                  ? "gray"
                  : "linear-gradient(135deg, #3A416F 0%, #141727 100%)",
                color: "white",
                "&:hover": {},
              }}
            >
              {formValue.id ? "Update" : "Submit"}
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BlockMasterFrom;
